export class TeleBirrCreateOrder {
  Currency = "";
  Amount = 0;
  NotifyUrl = "";
  RedirectUrl = "";
  Title = "";
  PNR = "";
}
